<template>
  <EditDialog
    v-model:visible="visible"
    :title="
      $t('views.layout.Dialog.ModifyPassword.154c18b9c0bea57368090b4582ef7751')
    "
    :sure-btn-width="120"
    is-show-cancl="true"
    :mask-closable="false"
    :hide-footer="false"
    :width="440"
    :padding="32"
    :z-index="1001"
    @submit="handleClick"
    @cancel="visible = false"
  >
    <DynamicsForm
      :model="model"
      :label-width="0"
      :setting="baseSetting"
      hide-required-mark
      :group-collapse="false"
    />
  </EditDialog>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { updateCompanyPasswordApi } from '@/api/auge';
import { DynamicsForm } from '@koi-design/vix-components';
import { defineComponent, ref, reactive } from 'vue';
import { message } from '@koi-design/uxd-ui';
import { checkCompanyPassword } from '@/libs/reg';
import { md5 } from '@koi-design/vix-tools';

export default defineComponent({
  components: {
    DynamicsForm
  },
  setup() {
    const { t } = useI18n();
    const visible = ref(false);
    const model = reactive({
      oldPassword: '',
      newPassword: '',
      newPasswordConfirmation: ''
    });
    const baseSetting = [
      {
        name: 'oldPassword',
        label: '',
        type: 'password',
        props: {
          placeholder: t(
            'views.layout.Dialog.ModifyPassword.00f6cac45231267efb620934cf1fec60'
          ),
          maxlength: 20
        }
      },
      {
        name: 'newPassword',
        label: '',
        type: 'password',
        props: {
          placeholder: t(
            'views.layout.Dialog.ModifyPassword.fa8ec3161d66f0c99dd8dc5af8b5793d'
          ),
          maxlength: 20
        }
      },
      {
        name: 'newPasswordConfirmation',
        label: '',
        type: 'password',
        props: {
          placeholder: t(
            'views.layout.Dialog.ModifyPassword.b8b2530173eb60c04ebf495275216a05'
          ),
          maxlength: 20
        }
      }
    ];
    const show = (flag = true) => {
      visible.value = flag;
      model.oldPassword = '';
      model.newPassword = '';
      model.newPasswordConfirmation = '';
    };
    const handleClick = async () => {
      if (!checkCompanyPassword(model.newPassword)) {
        message.error(
          t(
            'views.layout.Dialog.ModifyCompanyPassword.392d00abc1f06221a1b6cb0462dc3219'
          )
        );
        return;
      }
      if (model.newPassword !== model.newPasswordConfirmation) {
        message.error(
          t(
            'views.layout.Dialog.ModifyPassword.73e3d2b72de074a389ae3541f937cf7d'
          )
        );
        return;
      }
      try {
        const formData = new FormData();
        formData.append('oldPassword', md5(model.oldPassword));
        formData.append('newPassword', md5(model.newPassword));
        formData.append(
          'newPasswordConfirmation',
          md5(model.newPasswordConfirmation)
        );
        const res = await updateCompanyPasswordApi(formData);
        if (res) {
          visible.value = false;
        }
      } catch (error) {
        console.error(error);
      }
    };
    return {
      show,
      visible,
      model,
      handleClick,
      baseSetting
    };
  }
});
</script>
